import api from "core/api/api";
import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "MSSQL",

    getJDBCURL: (m) =>
        "jdbc:sqlserver://" +
        m.get("host") +
        ":" +
        m.get("port") +
        ";DatabaseName=" +
        m.get("dbName"),

    getConnectionParams: async (type, model) => getParams(type, model),

    async fetchTableWrapper(model, agentName, metaObjectFQN, adapterName_version) {
        const params = await getParams("SQLSERVER", model);
        return api.WizardHelper_GetSchemas("MSSQL", params, agentName, metaObjectFQN, adapterName_version);
    }
};
